$(document).ready(function(){
  var owl = $('.gray-new-collection .product-list');
  // Listen to owl events:
  function hide_arrows(){
    if($(".gray-new-collection .owl-item:last-child").hasClass('active')){
      $(".gray-new-collection .next.ltr-icon").addClass("hidden");
    }else if($(".gray-new-collection .owl-item:first-child").hasClass('active')){
      $(".gray-new-collection .prev.ltr-icon").addClass("hidden");
    }else{
      $(".gray-new-collection .prev.ltr-icon, .gray-new-collection .next.ltr-icon").removeClass("hidden");
    }
  }
  hide_arrows();
  owl.on('changed.owl.carousel', function(event) { 
    setTimeout(function(){ 
      hide_arrows();
    }, 100);
  });
});